import React, { Component } from 'react'
import { connect } from 'react-redux'
import { injectIntl } from 'react-intl'
import { withRouter } from 'react-router'
import Collection from '../collection/Collection'
import '../private-site/bootstrap.min.css'
import '../private-site/flickity.css'
import '../private-site/privateSite.css'
import { getExplore, emptyExplore, cleanDataBackExplore } from '../../actions/AssetsExploreAction'
//import Pagination from '../pagination/Pagination'
import { cancelSelect } from "../../actions/MultiselectAction";
import { getClientDataById } from '../../actions/ClientAction'
import PendingPaymentModal from "../../components/clients/PendingPaymentModal";
import { logout } from '../../actions/AuthAction'
import RenameModal from '../multi-selector-header-options/rename-modal/RenameModal'
import TagProtocolModal from '../multi-selector-header-options/tag-protocol-modal/TagProtocolModal'
import MoveModal from '../multi-selector-header-options/move-modal/MoveModal'
import DeleteModal from '../multi-selector-header-options/delete-modal/DeleteModal'
import ShareModal from '../multi-selector-header-options/share-modal/ShareModal'
import GroupModal from '../multi-selector-header-options/group-modal/GroupModal'
import { individualClear } from '../../actions/IndividualSelectAction';
import RenameFileModal from '../multi-selector-header-options/rename-file-modal/RenameFileModal'
import { isEnterpriseUser } from '../../utils/plan-utils'
import { LIMITE_PAGINA_CARPETA } from '../../utils'
import DownloadModal from '../multi-selector-header-options/download-modal/DownloadModal'
import { setSelectedFolderExplore } from '../../actions/AppAction'

export class Explore extends Component {
  constructor(props){
    super(props);
    this.state = {
      paymentUrl: "",
      showPendingPaymentModal: false,
    }
  }
  componentDidMount() {
    const { workclient, selectedFolderExplore } = this.props;
    if (workclient) {
      this.props.cleanDataBackExplore()
    }
    this.props.getClientDataById(workclient);
    const { folder } = this.props.match.params
    if (folder) {
      this.handleGetData(folder)
    } else {
      this.props.history.push(`/home`)
    }
    if (!selectedFolderExplore) {
      if (folder) {
        this.props.setSelectedFolderExplore(folder)
      } else {
        this.props.setSelectedFolderExplore(null)
      }
    }
  }

  componentDidUpdate(prevProps) {
    const { folder } = this.props.match.params;
    const { showPendingPaymentModal } = this.state;
    const { folderselect, clienteSelected, showScrolling, pageScrolling } = this.props

    if (prevProps.folderselect !== folder && folderselect !== folder) {
      this.props.cleanDataBackExplore()
      this.handleGetData(folder)
    }
    if(!clienteSelected.paymentStatus && !showPendingPaymentModal && !isEnterpriseUser(clienteSelected)){
      this.setState({
        showPendingPaymentModal: true
      });
    }
    if (showScrolling) {
      this.handleGetData(folder, pageScrolling)
    }
  }

  componentWillUnmount() {
    this.props.emptyExplore()
  }

  handleGetData = (folderselect, page = 1) => {
    const { workclient, dataExplore } = this.props
    // KAN-41: el 40 que estaba suelto aca es el mismo que necesita el
    // reordenamiento. Pasa por la constante para que no vuelvan a separarse.
    if (page !== 1) {
      this.props.getExplore(workclient, folderselect, page, null, true, dataExplore, LIMITE_PAGINA_CARPETA)
    } else {
      this.props.getExplore(workclient, folderselect, page, null, true, [], LIMITE_PAGINA_CARPETA)
    }
  }

  handleChangePage = page => {
    const { folderselect } = this.props
    this.handleGetData(folderselect, page)
  }

  render() {
    const {
      paymentUrl,
      showPendingPaymentModal,
      // exploreTourModalVisible
    } = this.state;
    //const { headers, page, limit } = this.props
    const { selectedFile, action } = this.props
    return (
      <React.Fragment>
        <Collection keyCollection='assetsExplore' />
        <PendingPaymentModal
          title = {"Estimado usuario, tiene un pago pendiente. Completelo para continuar usando Bunkey. Si ya pagó, espere unos minutos y recargue la página"}
          showPendingPaymentModal={showPendingPaymentModal}
          handleHidePendingPaymentModal={()=>{
            this.props.logout()
          }}
          closable = {false}
          paymentUrl = {paymentUrl}
          closeLabel={"Cerrar sesión"}
        />
        {selectedFile && action === "delete" && <DeleteModal
          showModal = {action === "delete"}
          handleHiddenModal = {()=>{
            this.props.individualClear()
          }}
        />}
        {selectedFile && action === "tag_protocol" && <TagProtocolModal
          showModal = {action === "tag_protocol"}
          handleHiddenModal = {()=>{
            this.props.individualClear()
          }}
        />}
        {selectedFile && action === "rename" && <RenameModal
          showModal = {action === "rename"}
          handleHiddenModal = {()=>{
            this.props.individualClear()
          }}
        />}
        {selectedFile && action === "move" && <MoveModal
          showModal = {action === "move"}
          handleHiddenModal = {()=>{
            this.props.individualClear()
          }}
        />}
        {selectedFile && action === "group" && <GroupModal
          showModal = {action === "group"} 
          handleHiddenModal = {()=>{
            this.props.individualClear()
          }}
        />}

        {selectedFile && action === "delete" && <DeleteModal
          showModal = {action === "delete"}
          handleHiddenModal = {()=>{
            this.props.individualClear()
          }}
        />}
        { selectedFile && action === "download" && <DownloadModal
          showModal = {action === "download"}
          handleHiddenModal = {()=>{
            this.props.individualClear()
          }}
        />}
        { selectedFile && action === "share" && <ShareModal
          showModal = {action === "share"}
          handleHiddenModal = {()=>{
            this.props.individualClear()
          }}
        />}
        { selectedFile && action === "renameFile" && <RenameFileModal
          showModal = {action === "renameFile"}
          handleHiddenModal = {()=>{
            this.props.individualClear()
          }}
        />}

        {/*<Pagination
          keyCollection='assetsExplore'
          handleChangePage={this.handleChangePage}
          page={page}
          limit={limit}
          headers={headers} />
          Paginacion vertical
          */}
      </React.Fragment>
    )
  }
}

const mapStateToProps = state => {
  return {
    workclient: state.client.workclient,
    folderselect: state.assetsExplore.folderselect,
    data: state.assetsExplore.data,
    headers: state.assetsExplore.headers,
    page: state.assetsExplore.page,
    limit: state.assetsExplore.limit,
    clienteSelected: state.client.data,
    selectedFile: state.individualSelect.selectedFile,
    action: state.individualSelect.action,
    selectedFolderExplore: state.app.selectedFolderExplore,
    showScrolling:  state.assetsExplore.showScrolling,
    dataExplore:  state.assetsExplore.data,
    pageScrolling: state.assetsExplore.pageScrolling
  }
}

const mapDispatchToProps = {
  getExplore,
  emptyExplore,
  cancelSelect,
  getClientDataById,
  logout,
  individualClear,
  setSelectedFolderExplore,
  cleanDataBackExplore
}

export default injectIntl(withRouter(connect(mapStateToProps, mapDispatchToProps)(Explore)))
